import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import {
  EditorialLayout,
  ModalContent,
  Text,
  Link as MedkitLink,
} from '@babylon/medkit'
import messages from './messages'

const ServiceNotAvailableModal = () => {
  const translate = useFormatMessage()

  return (
    <ModalContent title={translate(messages.pageTitle)}>
      <EditorialLayout>
        <Text variant="caption">{translate(messages.pageHeading)}</Text>
        <Text variant="body">
          {translate(messages.body1, {
            link: (
              <MedkitLink href={translate(messages.body1LinkHref)}>
                {translate(messages.body1LinkText)}
              </MedkitLink>
            ),
          })}
        </Text>
        <Text variant="body">{translate(messages.body2)}</Text>
        <Text variant="body">
          {translate(messages.body3, {
            link: (
              <MedkitLink href={translate(messages.body3LinkHref)}>
                {translate(messages.body3LinkText)}
              </MedkitLink>
            ),
          })}
        </Text>
      </EditorialLayout>
    </ModalContent>
  )
}

export default ServiceNotAvailableModal
